<template>
  <navbar>
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >
      &#9776;
    </button>

    <a class="navbar-brand" href="#" />

    <ul class="nav navbar-nav d-md-down-none mr-auto">
      <li class="nav-item">
        <a
          class="nav-link navbar-toggler sidebar-toggler"
          href="#"
          @click="sidebarToggle"
        >
          &#9776;
        </a>
      </li>
    </ul>
    <UploadManager />
  </navbar>
</template>
<script>
import UploadManager from '@/views/uploadManager/UploadManager';
import navbar from './Navbar';

export default {
  name: 'AppHeader',

  components: {
    navbar,
    UploadManager,
  },

  methods: {
    click() {
      // do nothing
    },
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
  },
};
</script>



// WEBPACK FOOTER //
// Header.vue?098a92e4